import { createContext, ReactNode, useContext } from 'react';

export interface NavigationGuardContextType {
	setGuard: (handler: () => boolean) => void;
	setShowDialogHandler: (handler: () => Promise<boolean>) => void;
	clearGuard: () => void;
}

const NavigationGuardContext = createContext<NavigationGuardContextType | null>(null);

export function NavigationGuardProvider({ children, value }: { children: ReactNode; value: NavigationGuardContextType }) {
	return <NavigationGuardContext.Provider value={value}>{children}</NavigationGuardContext.Provider>;
}

export function useNavigationGuard(): NavigationGuardContextType | null {
	return useContext(NavigationGuardContext);
}
